import React, { createContext, useContext, useRef, useState } from "react";
import { LoginRequiredModal } from "../View/Login/LoginRequiredModal";
import { useModalPopupManager } from "./modelPopupContext";

const LoginModalContext = createContext();

export const useLoginModal = () => useContext(LoginModalContext);
export const LoginModalProvider = ({ children }) => {
  const ref = useRef(null);
  const [config, setConfig] = useState({});
  const { registerModal } = useModalPopupManager();

  const showLoginModal = (options = {}) => {
    setConfig(options);
    console.log("showLoginModal called with options:", options);
    registerModal(ref.current, true);
    ref.current?.show();
  };
  const hideLoginModal = () => ref.current?.hide();

  return (
    <LoginModalContext.Provider value={{ showLoginModal, hideLoginModal }}>
      {children}
      <LoginRequiredModal
        ref={ref}
        title={config.title}
        heading={config.heading}
        description={config.description}
        onClose={config.onClose}
      />
    </LoginModalContext.Provider>
  );
};
